import React, {useEffect, useState} from 'react';
import SEO from '../Components/SEO';
import { createClient } from 'contentful';
import { useParams } from 'react-router-dom';
import HeroArticle from '../Components/Article/HeroArticle';
import FeaturedCasinos from '../Components/Casinos/FeaturedCasinos';
import Content from '../Components/Content';
import TableOfContent from '../Components/TableOfContent';
import SuchtBerat from '../Components/ColorBox';
import AuthorCard from '../Components/Author/AuthorCard';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import person from '../../assets/img/person.png';
import ArticleSlider from '../Components/Article/ArticleSlider';
import { transformEntryFields } from '../../utils/tokenReplace';

const News = () => {

  const [singleEntry, setSingleEntry] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const client = createClient({
    space: 'qzvdhv6dk1nu',
    environment: 'master',
    accessToken: 'yF08NDjz2PAvDXY7SsJ57o2vkwpxT1zOjunvfbNOx_4'
  })

  let { slug } = useParams();

  useEffect(() => {
    const getEntries = async () => {
      try {
        const entries = await client.getEntries({
          content_type: 'newsArticle',
          limit: 1,
          'fields.slug': slug,
        });

        // 2) Recursively transform placeholders in each fetched item
        entries.items.forEach((item) => {
          transformEntryFields(item);
        });

        setSingleEntry(entries);
        setIsDataLoaded(true);
      } catch (error) {
        console.log(error);
      }
    };
    getEntries();
  }, [slug]);

  if (!singleEntry) {
    return "Loading...";
  }

  return (
    <div className="container-fluid">
      {singleEntry?.items?.map((entry) =>
      <div className="single-entry single-news" key={entry?.sys?.id}>

        <SEO
          title={entry?.fields?.seoFields?.fields?.metaTitle ? 
            entry?.fields?.seoFields?.fields?.metaTitle 
          : entry?.fields?.title}
          metaTitle={
            entry?.fields?.seoFields?.fields?.metaTitle ? 
                entry?.fields?.seoFields?.fields?.metaTitle + ' | Casinos Vergleich'
              : entry?.fields?.title + ' | Casinos Vergleich'}
          description={
            entry?.fields?.seoFields?.fields?.metaDescription ? 
              entry?.fields?.seoFields?.fields?.metaDescription 
              : entry?.fields?.teaser ? entry?.fields?.teaser : ''}
          author={entry?.fields?.author?.fields?.name}
          authorUrl={'/autor/' + entry?.fields?.author?.fields?.slug}
          datePublished={entry?.sys?.createdAt}
          dateModified={entry?.sys?.updatedAt}
          article='true'
          fc_image={entry?.fields?.featuredImage?.fields?.file?.url + '?h=300'}
          fc_name={entry?.fields?.factCheck?.fields?.name ? entry?.fields?.factCheck?.fields?.name : ''}
          fc_claimAuthor={entry?.fields?.factCheck?.fields?.claimAuthor}
          fc_claimAuthorType={entry?.fields?.factCheck?.fields?.claimAuthorType ? 'Person' : 'Organisation'}
          fc_claimAuthorUrl={entry?.fields?.factCheck?.fields?.claimAuthorUrl}
          fc_claimHeadline={entry?.fields?.factCheck?.fields?.claimHeadline}
          fc_claimPublished={entry?.fields?.factCheck?.sys?.createdAt}
          fc_claimReviewed={entry?.fields?.factCheck?.fields?.claimReviewed}
          fc_claimUrl={entry?.fields?.factCheck?.fields?.claimUrl}
          fc_reviewRating={entry?.fields?.factCheck?.fields?.reviewRating}
          />

        <HeroArticle 
          title={entry?.fields?.title}
          parent={'News'}
          parentSlug={'news/'}
          featuredImage={entry?.fields?.featuredImage?.fields?.file?.url + '?h=300'}
          featuredImageDescription={entry?.fields?.featuredImage?.fields?.description}
          slug={entry?.fields?.slug}
          author={entry?.fields?.author?.fields?.name}
          authorLink={'/autor/' + entry?.fields?.author?.fields?.slug}
          createdAt={entry?.sys?.createdAt}
          externalLink={''}
          popupCasino={entry?.fields?.popupCasino ? entry?.fields?.popupCasino : ''}
          pt={entry?.fields?.popupTitle}
          plp={entry?.fields?.popupLinkProminent ? entry?.fields?.popupLinkProminent : ''}
          pl={entry.fields?.popupLink ? entry.fields?.popupLink : ''}
          ptbt = {entry?.fields?.popupTBT}
          ></HeroArticle>

        {/* Featured Casinos */}
        { isDataLoaded ? <FeaturedCasinos id={entry?.sys?.id}></FeaturedCasinos> : null }

        {/* Container */}       
        <div className="container row m-auto flex-column-reverse flex-lg-row px-0">

          {/*Main Content*/}
          <main className="contentclass col-12 col-lg-8">
          { isDataLoaded ? <Content id={entry?.sys?.id}></Content> : null }

          <AuthorCard
            name = {entry?.fields?.author?.fields?.name}
            avatar = {entry?.fields?.author?.fields?.avatar ? entry?.fields?.author?.fields?.avatar?.fields?.file?.url + '?h=100' : person}
            slug = {'autor/' + entry?.fields?.author?.fields?.slug}
            excerpt = {documentToReactComponents(entry?.fields?.author?.fields?.bio)}></AuthorCard>

          <SuchtBerat></SuchtBerat>

          <ArticleSlider 
          slugBase={'/news/'}
          contentType={'newsArticle'}
          id={entry?.sys?.id}/>

          </main>
          {/*end::Main Content*/}

          {/*Sidebar*/}
          <div className="col-12 col-lg-4">
          <TableOfContent></TableOfContent>
          </div>
          {/*end::Sidebar*/}

          </div>
          {/* end::Container */}

      </div>
)}
    </div>
  )
}

export default News